// Inline form field validation constants
export const PASSWORD_REQUIRED_CHARACTERS_REGEX =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?\-#&])[A-Za-z\d@$!%*?\-#&]{12,}$/;
